import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
import { useRouter } from 'vue-router'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:3006/api',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Add request interceptor to add auth token and organization
api.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore()
    if (authStore.isAuthenticated) {
      config.headers.Authorization = `Bearer ${authStore.currentUser.token}`
      if (authStore.organizationSlug) {
        config.headers['X-Organization'] = authStore.organizationSlug
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Add response interceptor to handle errors
api.interceptors.response.use(
  response => {
    // Return the actual response data
    return response.data
  },
  error => {
    if (error.response?.status === 401) {
      // Clear user data
      const authStore = useAuthStore()
      authStore.clearAuth()
      
      // Don't redirect if we're already on the login or register page
      const currentPath = window.location.pathname
      if (currentPath !== '/login' && currentPath !== '/register') {
        try {
          const router = useRouter()
          if (router && router.push) {
            router.push('/login')
          } else {
            // Fallback if router is undefined
            console.warn('Router is undefined in API interceptor, using window.location')
            window.location.href = '/login'
          }
        } catch (routerError) {
          console.error('Error using router in API interceptor:', routerError)
          // Fallback if router throws an error
          window.location.href = '/login'
        }
      }
    }
    return Promise.reject(error)
  }
)

export default api 